import { render, staticRenderFns } from "./enrolled-list.vue?vue&type=template&id=9fa0dbe6&"
import script from "./enrolled-list.vue?vue&type=script&lang=js&"
export * from "./enrolled-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fa0dbe6')) {
      api.createRecord('9fa0dbe6', component.options)
    } else {
      api.reload('9fa0dbe6', component.options)
    }
    module.hot.accept("./enrolled-list.vue?vue&type=template&id=9fa0dbe6&", function () {
      api.rerender('9fa0dbe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/beneficiary/enrolled-list.vue"
export default component.exports